import { render, staticRenderFns } from "./NonGTATotals.vue?vue&type=template&id=c618dc10"
import script from "./NonGTATotals.vue?vue&type=script&lang=js"
export * from "./NonGTATotals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports